export default __webpack_public_path__ + "static/media/wsoclogo.3b290ad0.png";